import React, { useCallback, useEffect, useState } from "react"
import Block from "@bappweb/block"
import Element from "@bappweb/element"
import MainForm from "./form"
import LandingHeader from "./landingheader"
import SssList from "./ssslist"
import Notes from "./notes"
import { useAppDispatch, useAppSelector } from "../../../config/hook"
import { setIsDetails } from "src/projects/kredi-karti/state/isDetails"
import { pushGtmValues } from "@bappweb/utils"
import { showChatbot } from "src/projects/kredi-karti/utils/utils"
import { getConfigValue, isNullOrEmpty } from "@smpu-web/utils/utils"
import { setSessionData } from "src/projects/kredi-karti/state/sessionData"
import  globalChatbotTimer from '../../../utils/globalChatbotTimer'

declare global {
    interface Window {
        __chatbotScriptInjected?: boolean;
    }
}
const Landing = () => {

    const dispatch = useAppDispatch()
    const sessionData = useAppSelector((state) => state.sessionData.response)
    const [scriptReady, setScriptReady] = useState(false);

    // Script yükleme
    useEffect(() => {
        if (!isNullOrEmpty(getConfigValue(sessionData?.configList, "CreditCard.Chatbot.Url")) && !sessionData?.isChatbotUrlAddedToLandingPage) {
            if (window.__chatbotScriptInjected) {
                setScriptReady(true);
                return;
            }
            const existing = document.getElementById("chatbot-loader-script") as HTMLScriptElement | null;
            if (existing) {
                existing.addEventListener("load", () => setScriptReady(true), { once: true });
                return;
            }
            const s = document.createElement("script");
            s.id = "chatbot-loader-script";
            s.defer = true;
            s.src = getConfigValue(sessionData?.configList, "CreditCard.Chatbot.Url");
            s.onload = () => {
                window.__chatbotScriptInjected = true;
                setScriptReady(true);
            };
            s.onerror = () => console.error("Chatbot script yüklenemedi.");
            document.body.appendChild(s);
            dispatch(
                setSessionData({
                    isChatbotUrlAddedToLandingPage: true
                })
            )
        }
    }, [sessionData]);

    useEffect(() => {
        if (sessionData?.configList) {
            const chatbotTimeout = getConfigValue(sessionData?.configList, "CreditCard.Chatbot.Timeout")
            globalChatbotTimer.start(Number(chatbotTimeout) || 5000);
            const handleShowChatbot = () => {
                showChatbot();
            };
            globalChatbotTimer.addCallback(handleShowChatbot);
            return () => {
                globalChatbotTimer.removeCallback(handleShowChatbot);
            };
        }
    }, [sessionData?.configList]);

    dispatch(
        setIsDetails({
            isDetails: false
        })
    )
    useEffect(() => {
        pushGtmValues({
            event: "virtual_page_view",
            content_group: "kredi_karti",
            pageName: "/basvuru/kredi-karti/0/landing",
            pageTitle: 'Bireysel Kredi Karti'
        })
    }, []);

    return (
        <Block>
            <LandingHeader />
            <MainForm />
            <Notes />
            <SssList />
        </Block>
    )
}

export default Landing
